import { Component, DestroyRef, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { AppRoutingService, SessionService } from '@ui-components/services';
import { AdminNavItem } from '@ui-components/admin/nav';
import { CookieService } from 'ngx-cookie-service';
import { filter, map } from 'rxjs';
import { AdminSessionService } from './services/admin-session.service';
import { AdminMoveSelectionService } from './services/admin-move-selection.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {

  activePath: string;
  navItems: AdminNavItem[] = [
    { label: 'Dashboard', icon: 'dashboard', path: '/dashboard' },
    { label: 'Organizations', icon: 'corporate_fare', path: '/organizations' },
    { label: 'People', icon: 'group', path: '/people' },
    { label: 'Assessments', icon: 'assignment', path: '/assessments' }
  ];
  profile: { first_name: string; last_name: string } | null = null;
  title = 'owlhub-admin';
  accountHref = '';
  bare = false;
  private destroyRef: DestroyRef;

  constructor(
    protected _cookie_service: CookieService,
    protected _session_service: SessionService,
    protected _selection: AdminMoveSelectionService,
    private _admin_session_service: AdminSessionService,
    private _app_routing_service: AppRoutingService,
    private _router: Router,
    destroyRef: DestroyRef
  ) {
    this.destroyRef = destroyRef;
    this.activePath = this._router.url;
  }

  ngOnInit(): void {
    this.accountHref = this._app_routing_service.getAssessmentsUrl();
    this.bare = this._router.url.startsWith('/no-access');

    this._router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.urlAfterRedirects),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((url: string) => {
      this.activePath = url;
      this.bare = url.startsWith('/no-access');
    });

    this._admin_session_service.profile().pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((profile: { first_name: string; last_name: string } | null) => {
      this.profile = profile;
    });

    if (this._cookie_service.get('access_token')) {
      this._session_service.startIdleWatch();
    }
  }

  ngOnDestroy(): void {
    this._session_service.stopIdleWatch();
  }

  onSignOut(): void {
    this._session_service.logout();
  }

}
